export default __webpack_public_path__ + "static/social-fb8a667628ce604bad30d5ee7d67be9a.jpg";